require('../modules/esnext.promise.try');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/proposals/promise-try.js
// module id = 650
// module chunks = 5